import React, {useEffect, useRef} from 'react'
import {observer} from 'mobx-react'

import ProcedureHeader from './ProcedureHeader'
import ProcedureMain from './ProcedureMain/ProcedureMain'
import ProcedureFooter from './ProcedureFooter/ProcedureFooter'
import ProcedureSidebar from "./ProcedureSidebar/ProcedureSidebar";

import './procedurePlayer.scss'
import Utility from "../../Utility";
import ConditionalComponent from "../Shared/ConditionalComponent";
import PropTypes from "prop-types";
import {useStores} from "../../Hooks";
import {procedureTypeEnum} from "../../serverClientShared/sharedEnums";
import WebGL3dPlayer from "../../WebGL/WebGL3dPlayer";


const ProcedurePreviewPlayer = observer(({
                                             procedure,
                                             backgroundColorLeft,
                                             backgroundColorRight,
                                             backgroundImageAddress,
                                             isBackgroundColor,
                                             // isStreamable,
                                             dataFetched,
                                             selectedNodeId,
                                             fromEditor
                                         }) => {

    const {procedureStore, generalStore} = useStores();

    const fullScreenRef = useRef();

    const {previewSidebar} = procedureStore;
    const mediaProcedureFile = procedure ? procedure.MediaProcedureFile : null;
    let player = null;
    const procedureType = procedure.ProcedureType || procedureTypeEnum.REGULAR;
    let withoutFooter = false;

    useEffect(() => {
        procedureStore.currentPreviewedProcedure = procedure;
        procedureStore.clearWarningAcknowledgements(true);
        if (!procedureStore.sessionViewerOpen || procedureStore.currentSessionIndex === 0) {
            procedureStore.resetPreviewedProcedure().then(() => {
                if (!!selectedNodeId) {
                    procedureStore.goToPreviewNode(selectedNodeId).then();
                    procedureStore.makeCurrentPreviewedStepCanonical();
                }
            });
        }

        return () => {
            procedureStore.previewSidebar = false;
        }
        // eslint-disable-next-line
    }, [procedure, selectedNodeId]);

    if (procedure) {
        // noinspection JSUnreachableSwitchBranches
        if (!!mediaProcedureFile) {
            player = <>
                <div className='file-preview-container'>
                    {Utility.renderFilePreview(mediaProcedureFile, generalStore.translate)}
                </div>
                <ProcedureFooter isPreview={true} fullscreenRefElement={fullScreenRef.current}/>
            </>
        }
        switch (procedureType) {
            // case procedureTypeEnum.SITE_PREP:    //TODO fix when Unity site prep finished
            case procedureTypeEnum.FUSION:
                withoutFooter = true;

                if (dataFetched) {
                    player = <WebGL3dPlayer procedure={procedure} isPreview={true}/>;
                }
                break;

            default:
                if (!mediaProcedureFile) {
                    player = <>
                        <ProcedureMain
                            isPreview={true}
                            key={procedureStore.currentPreviewedStep}
                            fromEditor={fromEditor}
                        />
                        <ProcedureFooter isPreview={true} fullscreenRefElement={fullScreenRef.current}/>
                    </>
                }
        }
    }

    const playerStyle = Utility.getPlayerStyle(isBackgroundColor, backgroundColorRight, backgroundColorLeft, backgroundImageAddress);
    return (
        <div className='procedure-player-summary-container' ref={fullScreenRef}>
            <div className={`run-procedure-container${generalStore.isInFullscreen ? "" : " standard-view"}`}>

                <div className={`procedure-player-container${generalStore.isInFullscreen ? " in-fullscreen" : ''}`}>
                    <ProcedureHeader isPreview={true} withFullscreen={false}/>
                    <div
                        className="procedure-body"
                        style={playerStyle}
                    >

                        <ConditionalComponent if={previewSidebar}>
                            <ProcedureSidebar isPreview={true}/>
                        </ConditionalComponent>
                        <div
                            className={`procedure-body-container ${procedure.ProcedureType === procedureTypeEnum.FUSION ? 'digital-twin' : ''}` + (procedure.ProcedureType === procedureTypeEnum.FUSION ? ' frontline-3d' : '') + (withoutFooter ? ' without-footer' : '') + (generalStore.isInFullscreen ? ' in-fullscreen' : '')}>
                            {player}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
});

ProcedurePreviewPlayer.propTypes = {
    procedure: PropTypes.object.isRequired,
    startNodeIdentifier: PropTypes.string,
    backgroundColorRight: PropTypes.string,
    backgroundColorLeft: PropTypes.string,
    backgroundImageAddress: PropTypes.string,
    isBackgroundColor: PropTypes.bool.isRequired
}

export default ProcedurePreviewPlayer
